import { render, staticRenderFns } from "./questionBank.vue?vue&type=template&id=e783ff96&scoped=true"
import script from "./questionBank.vue?vue&type=script&lang=js"
export * from "./questionBank.vue?vue&type=script&lang=js"
import style0 from "./questionBank.vue?vue&type=style&index=0&id=e783ff96&prod&scoped=true&lang=css"
import style1 from "./questionBank.vue?vue&type=style&index=1&id=e783ff96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e783ff96",
  null
  
)

export default component.exports